module.exports = __webpack_public_path__ + "static/media/Oscar_Gandara_Resume_website.70fe8521.pdf";